var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../../lib/utils';
export var ResponsiveContainer = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, _c = _a.enableMobileTabs, enableMobileTabs = _c === void 0 ? false : _c;
    var _d = React.useState(false), isMobile = _d[0], setIsMobile = _d[1];
    React.useEffect(function () {
        var checkMobile = function () {
            setIsMobile(window.innerWidth < 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return function () { return window.removeEventListener('resize', checkMobile); };
    }, []);
    var getContainerClasses = function () {
        var baseClasses = "w-full mx-auto min-w-0 overflow-hidden"; // Added min-w-0 and overflow-hidden
        var variantClasses = {
            default: cn("max-w-7xl", isMobile ? "px-3 py-3" : "px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8"),
            'full-width': cn("max-w-none", isMobile ? "px-2 py-2" : "px-2 sm:px-4 lg:px-6 py-2 sm:py-4 lg:py-6"),
            compact: cn("max-w-5xl", isMobile ? "px-2 py-2" : "px-3 sm:px-4 lg:px-6 py-3 sm:py-4 lg:py-6")
        };
        // Reduce mobile tabs bottom padding since main container now handles it
        var mobileTabsClasses = enableMobileTabs && isMobile
            ? "pb-4" // Minimal padding since main container handles safe area
            : "";
        return cn(baseClasses, variantClasses[variant], mobileTabsClasses, className);
    };
    return (_jsx("div", __assign({ className: getContainerClasses() }, { children: children })));
};
export var LayoutGrid = function (_a) {
    var children = _a.children, _b = _a.columns, columns = _b === void 0 ? 1 : _b, _c = _a.gap, gap = _c === void 0 ? 'md' : _c, className = _a.className;
    var gapClasses = {
        sm: 'gap-2 sm:gap-3 lg:gap-4',
        md: 'gap-3 sm:gap-4 lg:gap-6',
        lg: 'gap-4 sm:gap-6 lg:gap-8'
    };
    var getGridClasses = function () {
        if (columns === 1)
            return 'grid grid-cols-1';
        if (columns === 2)
            return 'grid grid-cols-1 md:grid-cols-2';
        if (columns === 3)
            return 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
        if (columns === 4)
            return 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4';
        return 'grid grid-cols-1';
    };
    return (_jsx("div", __assign({ className: cn(getGridClasses(), gapClasses[gap], className) }, { children: children })));
};
export var ResponsiveCard = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.padding, padding = _b === void 0 ? 'md' : _b, _c = _a.variant, variant = _c === void 0 ? 'default' : _c;
    var paddingClasses = {
        sm: 'p-3 sm:p-4',
        md: 'p-4 sm:p-6',
        lg: 'p-6 sm:p-8'
    };
    var variantClasses = {
        default: 'bg-background border border-border rounded-lg',
        bordered: 'bg-background border-2 border-border rounded-lg',
        elevated: 'bg-background border border-border rounded-lg shadow-md hover:shadow-lg transition-shadow'
    };
    return (_jsx("div", __assign({ className: cn(variantClasses[variant], paddingClasses[padding], className) }, { children: children })));
};
